import { addDays, addMonths, addWeeks, addYears, subDays, subMonths, subWeeks, subYears, } from "date-fns";
var functionObjAdd = {
    day: addDays,
    week: addWeeks,
    month: addMonths,
    year: addYears
};
var functionObjSub = {
    day: subDays,
    week: subWeeks,
    month: subMonths,
    year: subYears
};
export var formatDateToString = function (date) {
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return "".concat(day.toString().padStart(2, "0"), "/").concat(month
        .toString()
        .padStart(2, "0"), "/").concat(year);
};
export var fillDaysArray = function (arr) {
    var firstDay = arr[0];
    for (var i = 1; i <= firstDay.getDay(); i++) {
        var date = subDays(firstDay, i);
        arr.unshift(date);
    }
    var multiplier = Math.ceil(arr.length / 7);
    var left = 7 * multiplier - arr.length;
    var lastDay = arr[arr.length - 1];
    for (var i = 1; i <= left; i++) {
        var date = addDays(lastDay, i);
        arr.push(date);
    }
};
export var incrementPeriod = function (_a) {
    var p = _a.p, date = _a.date;
    return {
        start: functionObjAdd[p](date.start, 1),
        end: date.end ? functionObjAdd[p](date.end, 1) : null
    };
};
export var decrementPeriod = function (_a) {
    var p = _a.p, date = _a.date;
    return {
        start: functionObjSub[p](date.start, 1),
        end: date.end ? functionObjSub[p](date.end, 1) : null
    };
};
export var hexToRgb = function (hex) {
    // Remove the hash symbol (#) if it's included
    hex = hex.replace(/^#/, "");
    // Parse the hexadecimal string to separate red, green, and blue values
    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    // Return the RGB values as an object
    return {
        normal: "rgb( ".concat(r, ", ").concat(g, ", ").concat(b, " )"),
        hover: "rgba( ".concat(r, ", ").concat(g, ", ").concat(b, ", 0.15)")
    };
};
//# sourceMappingURL=functions.js.map